// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aN7C","col":"styles_col__1DMNA"};